<!-- assessment-share-popup.component.html -->

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="assign-modal-container"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <ng-template pTemplate="header">
      <h2 class="modal-title">{{config?.header}}</h2>
      <button class="close-button" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
  </ng-template>

  <p>Current Due Date: {{ config?.currentDueDate}}</p><br>

  <div class="modal-body">
    <form [formGroup]="dueDateExtensionForm" autocomplete="off" style="display: flex; flex-direction: column; gap: 1rem;">
      <div class="form-group">
        <label for="newDueDate">New Due Date <span class="required">*</span></label>
        <p-calendar
          id="newDueDate"
          formControlName="newDueDate"
          [showIcon]="true"
          dateFormat="yy-mm-dd"
          placeholder="Select New Due Date"
          [appendTo]="'body'"
          [minDate]="minDate"
          [readonlyInput]="true"
          [ngClass]="{ 'ng-invalid ng-dirty': formSubmitted && dueDateExtensionForm.controls['newDueDate'].invalid }"
        ></p-calendar>
      </div>

      <!-- Remarks field -->
      <div class="form-group">
        <label for="remarks" class="remark-label">Remarks<span class="required">*</span></label>
        <textarea
          id="remarks"
          pInputTextarea
          rows="2"
          placeholder="Reason for the due date extension"
          formControlName="remarks"
          class="textarea-container"
        ></textarea>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary"
        (click)="close()"
      ></button>
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-warning"
        (click)="onSubmit()"
      ></button>
    </div>
  </ng-template>
</p-dialog>